import HEULIEZ_Logo_RGB from './HEULIEZ_Logo_RGB.svg';
import HEULIEZ_Logo_White from './HEULIEZ_Logo_White.svg';
import IVECO_BUS_Logo_RGB_web from './IVECO_BUS_Logo_RGB_web.svg';
import IVECO_BUS_Logo_WHITE_web from './IVECO_BUS_Logo_WHITE_web.svg';
import IVG_Logo_FullBrands_Black_Web from './IVG_Logo_FullBrands_Black_Web.svg';
import IVG_Logo_FullBrands_RGB_Web from './IVG_Logo_FullBrands_RGB_Web.svg';
import IVG_Logo_FullBrands_White_BlueDot_Web from './IVG_Logo_FullBrands_White_BlueDot_Web.svg';
import IVG_Logo_FullBrands_White_Web from './IVG_Logo_FullBrands_White_Web.svg';
import IVG_Logo_Horizontal_Version_Web from './IVG_Logo_Horizontal_Version_Web.svg';
import IVG_Logo_Horizontal_White_Version_Web from './IVG_Logo_Horizontal_White_Version_Web.svg';
import IVG_Logo_Vertical_White_Version_Web from './IVG_Logo_Vertical_White_Version_Web.svg';
//import  from './.svg';

export {
    HEULIEZ_Logo_RGB,
    HEULIEZ_Logo_White,
    IVECO_BUS_Logo_RGB_web,
    IVECO_BUS_Logo_WHITE_web,
    IVG_Logo_FullBrands_Black_Web,
    IVG_Logo_FullBrands_RGB_Web,
    IVG_Logo_FullBrands_White_BlueDot_Web,
    IVG_Logo_FullBrands_White_Web,
    IVG_Logo_Horizontal_Version_Web,
    IVG_Logo_Horizontal_White_Version_Web,
    IVG_Logo_Vertical_White_Version_Web,
}